<!-- Calendar = MainCalendar + MainHoldiay + MainDayOff -->
<template>
    <div style="position: relative;">
        <loading :active.sync="loading" :is-full-page="false"> </loading>
        <b-card class="calendar-wrap">
            <b-card-body fluid>
                <b-card-title class="card-title">
                    Calendar</b-card-title>
                <div class="content">
                    <div class="content-wrap">
                        <div class="content-left">
                            <div class="calendar">
                                <div class="calendar-title">
                                    <span v-on:click="onClickToday()">
                                        {{ currentYear }}년 {{ currentMonth }}월
                                    </span>
                                    <div class="pagination">
                                        <a href="#" v-on:click="onClickPrev(currentMonth)" class="btn-prev"></a>
                                        <a href="#" v-on:click="onClickNext(currentMonth)" class="btn-next"></a>
                                    </div>
                                </div>
                                <table class="calendar-table">
                                    <thead>
                                        <tr>
                                            <th v-for="(weekName, index) in weekNames" v-bind:key="index"
                                                :class="{ 'sun' : index === 0, 'sat' : index === 6 }">
                                                {{ weekName }}
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(row, index) in currentCalendarMatrix" :key="index">
                                            <td v-for="(day, index2) in row" :key="index2">
                                                <div class="date" :class="{'today' : isToday(currentYear, currentMonth, day)}">
                                                    <!-- <div v-if="isToday(currentYear, currentMonth, day)">
                                                        <div class="today">
                                                            <span>{{ day }}</span>
                                                        </div>
                                                    </div> 날짜 숫자 -->
                                                    <div v-if="isHoliday(currentYear, currentMonth, day)" class="holiday"
                                                        style="color: #FF0000;">
                                                        <div class="day-text"><span>{{ day }}</span></div>
                                                        <div class="holiday-text">
                                                            {{ isHoliday(currentYear, currentMonth, day) }}
                                                        </div>
                                                    </div>
                                                    <div v-else-if="index2 == 0"
                                                        style="color: #FF0000;">
                                                        <!-- 지난달 일요일 날짜 표시 -->
                                                        <div v-if="day > 1000" class="day-text" style="color: rgba(255, 0, 0, 0.3);">
                                                            <span>{{ day % 1000 }}</span>
                                                        </div>
                                                        <div v-else class="day-text">
                                                            <span>{{ day }}</span>
                                                        </div>
                                                    </div>
                                                    <div v-else-if="index2 == 6"
                                                        style="color: #1755CC;">
                                                        <!-- 지난달 토요일 날짜 표시 -->
                                                        <div v-if="day > 1000" class="day-text" style="color: rgba(23, 85, 204, 0.3);">
                                                            <span>{{ day % 1000 }}</span>
                                                        </div>
                                                        <div v-else class="day-text" >
                                                            <span>{{ day }}</span>
                                                        </div>
                                                    </div>
                                                    

                                                    <div v-else>
                                                        <!-- 지난달 일반 날짜 표시 -->
                                                        <div v-if="day > 1000" class="day-text" style="color: rgba(46, 46, 56, 0.3);">
                                                            <span>{{ day % 1000 }}</span>
                                                        </div>
                                                        <div v-else class="day-text">
                                                            <span>{{ day }}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <!-- 휴가 명단 -->
                                                <div class="dayoff-list">
                                                    <!--Dayoff "000외 0명" -->
                                                    <div v-if="getDayOffList(day).length >= 4">
                                                        <div v-for="(dayOffList, index) in getDayOffList(day).slice(0, 3)"
                                                            :key="index" :title="dayOffList.userId" class="user">
                                                            {{ dayOffList.userName }}
                                                        </div>
                                                        <span class="others">
                                                            외 {{ getDayOffList(day).length - 3 }} 명
                                                        </span>
                                                        <div class="balloon-left">
                                                            <div v-for="(dayOffList, index) in getDayOffList(day)"
                                                                :key="index" :title="dayOffList.userId">
                                                                {{ dayOffList.userName }}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div
                                                        v-else-if="getDayOffList(day).length >= 1 && getDayOffList(day).length < 4">
                                                        <div v-for="(dayOffList, index) in getDayOffList(day)"
                                                            :key="index" :title="dayOffList.userId" class="user">
                                                            {{ dayOffList.userName }}
                                                        </div>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div class="content-right">
                            <b-tabs card>
                                <b-tab title="Day Off">
                                    <chatter-day-off @sendIsDayOffUpdated="getIsDayOffUpdated"> </chatter-day-off>
                                </b-tab>
                                <b-tab title="Holiday">
                                    <chatter-holiday @sendIsHolidayUpdated="getIsHolidayUpdated" :mainCalendarHolidayList="holidayList"></chatter-holiday>
                                </b-tab>
                            </b-tabs>
                        </div>
                    </div>
                    <div class="calendar-graph">
                            <calendar-graph :currYearHolidayList="currentYearHolidayList"
                                :currYearCalendarMatrix="currentYearCalendarMatrix"
                                :currYear="currentYear"></calendar-graph>
                    </div>
                </div>
            </b-card-body>
        </b-card>
    </div>
</template>

<script>

import CalendarGraph from "@/components/chatter/calendar/chart/CalendarGraph.vue";
import ChatterHoliday from "@/components/chatter/calendar/ChatterMainHoliday.vue";
import ChatterDayOff from "@/components/chatter/calendar/ChatterMainDayOff.vue";
export default {
    name: 'ChatterMainCalendar',
    created() {
        this.retrieveHolidayList();
        this.retrieveDayOff();
    },
    components: {
        CalendarGraph,
        ChatterHoliday,
        ChatterDayOff
    },
    watch: {
        currentYear() {
            //현재 선택한 연도의 휴일 리스트(CalendarGraph.vue에 반영하기 위한 데이터)
            this.currentYearHolidayList = this.holidayList.filter(obj => obj.holidayDate.slice(0, 4) == this.currentYear);
            this.setCurrentYearCalendar();
        }
    },
    data() {
        return {
            loading: false,
            weekNames: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
            rootYear: 1904,
            rootDayOfWeekIndex: 4,
            currentYear: new Date().getFullYear(),
            currentMonth: new Date().getMonth() + 1,
            currentDay: new Date().getDate(),
            currentMonthStartWeekIndex: null,
            currentCalendarMatrix: [],
            endOfDay: null,
            holidayList: [],
            holidaysMap: new Map(),
            dayOffList: [],
            previousEndOfDay: 1000,
            currentUser: this.$store.getters['auth/currentUser'],
            dayOff: {
                dayOffDate: null,
                hours: 8,
                message: null
            },
            currentYearHolidayList: [],
            //CalendarGraph.vue 에 전달할 한 해의 달력
            currentYearCalendarMatrix: []
        }
    },
    methods: {
        async retrieveHolidayList() {
            try {
                this.loading = true;
                const response = await axios.get("chatter/retrieveAllHolidays", {
                    headers: {
                        'Accept': 'application/json',
                        'Authorization': accessToken()
                    }
                });
                //시간 내림차순
                this.holidayList = response.data.reverse();
                this.holidaysMap = new Map();
                for (let i = 0; i < this.holidayList.length; i++) {
                    this.holidaysMap.set(this.holidayList[i].holidayDate, this.holidayList[i].holidayName);
                }
                this.currentYearHolidayList = this.holidayList.filter(obj => obj.holidayDate.slice(0, 4) == this.currentYear);
                this.setCurrentYearCalendar();
                this.init();
            }
            catch (error) {
                this.showError(error);
                this.loading = false;
            }
            finally {
                this.loading = false;
            }
        },
        //모든 직원의 휴가 정보
        async retrieveDayOff() {
            try {
                this.loading = true;
                const response = await axios.get("chatter/retrieveDayOff", {
                    headers: {
                        'Accept': 'application/json',
                        'Authorization': accessToken()
                    },
                    params: {
                        pageSize: 999
                    }
                });
                this.dayOffList = response.data;
            }
            catch (error) {
                this.showError(error);
                this.loading = false;
            }
            finally {
                this.loading = false;
            }
        },
        init() {
            this.previousEndOfDay = 1000;
            this.currentMonthStartWeekIndex = this.getStartWeek(this.currentYear, this.currentMonth);
            this.endOfDay = this.getEndOfDay(this.currentYear, this.currentMonth);
            //이전달 정보 초기화
            if (this.currentMonth == 1)
                this.previousEndOfDay += this.getEndOfDay(this.currentYear - 1, 12);
            else
                this.previousEndOfDay += this.getEndOfDay(this.currentYear, this.currentMonth - 1);
            this.initCalendar();
        },
        //한 해 달력 생성(currentYear 기준)
        setCurrentYearCalendar() {
            this.currentYearCalendarMatrix = [];
            this.previousEndOfDay = 1000;
            for (var month = 1; month < 13; month++) {
                //해당 월의 달력
                var monthMatrix = [];
                var monthStartWeekIndex = this.getStartWeek(this.currentYear, month);
                this.endOfDay = this.getEndOfDay(this.currentYear, month);
                //이전달 정보 초기화
                if (month == 1)
                    this.previousEndOfDay += this.getEndOfDay(this.currentYear - 1, 12);
                else
                    this.previousEndOfDay += this.getEndOfDay(this.currentYear, month - 1);
                let day = 1;

                for (var i = 0; i < 6; i++) {
                    var calendarRow = [];
                    //해당 월의 전체 week 수
                    var totalWeeks = 0;
                    var afterDay = 1001;
                    for (var j = 0; j < 7; j++) {
                        if (i == 0 && j < monthStartWeekIndex + 1) {
                            calendarRow.push("");
                            totalWeeks++;
                        }
                        else if (day <= this.endOfDay) {
                            calendarRow.push(day);
                            day++;
                        }
                        else {
                            calendarRow.push(afterDay);
                            afterDay++;
                            if (day > this.endOfDay)
                                totalWeeks++;
                        }
                    }
                    //매달 첫 주에 이전달 날짜 표시
                    if (i == 0) {
                        for (var k = 6; k >= 0; k--) {
                            if (calendarRow[k] == '') {
                                calendarRow[k] = this.previousEndOfDay;
                                this.previousEndOfDay--;
                            }
                        }
                    }
                    if (totalWeeks < 7) {
                        monthMatrix.push(calendarRow);
                    }
                }
                this.currentYearCalendarMatrix.push(monthMatrix);
            }
        },
        //현재달의 달력 생성
        initCalendar() {
            this.currentCalendarMatrix = [];
            let day = 1;
            for (let i = 0; i < 6; i++) {
                let calendarRow = [];
                var cnt = 0;
                var afterDay = 1001;
                for (let j = 0; j < 7; j++) {
                    if (i == 0 && j < this.currentMonthStartWeekIndex + 1) {
                        calendarRow.push('');
                        cnt++;
                    }
                    else if (day <= this.endOfDay) {
                        calendarRow.push(day);
                        day++;
                    }
                    else {
                        calendarRow.push(afterDay);
                        afterDay++;
                        if (day > this.endOfDay)
                            cnt++;
                    }
                }
                //매달 첫 주에 이전달 날짜 표시
                if (i == 0) {
                    for (let k = 6; k >= 0; k--) {
                        if (calendarRow[k] == '') {
                            calendarRow[k] = this.previousEndOfDay;
                            this.previousEndOfDay--;
                        }
                    }
                }
                if (cnt < 7) {
                    this.currentCalendarMatrix.push(calendarRow);
                }
            }
        },
        getEndOfDay(year, month) {
            switch (month) {
                case 1:
                case 3:
                case 5:
                case 7:
                case 8:
                case 10:
                case 12:
                    return 31;
                case 4:
                case 6:
                case 9:
                case 11:
                    return 30;
                case 2:
                    //윤년
                    if ((year % 4 == 0) && (year % 100 != 0) || (year % 400 == 0)) {
                        return 29;
                    }
                    else {
                        return 28;
                    }
            }
        },
        getStartWeek(currentYear, currentMonth) {
            let year = this.rootYear;
            let month = 1;
            let sumOfDay = this.rootDayOfWeekIndex;
            while (true) {
                if (currentYear > year) {
                    for (let i = 0; i < 12; i++) {
                        sumOfDay += this.getEndOfDay(year, month + i);
                    }
                    year++;
                }
                else if (currentYear == year) {
                    if (currentMonth > month) {
                        sumOfDay += this.getEndOfDay(year, month);
                        month++;
                    }
                    else if (currentMonth == month) {
                        return (sumOfDay) % 7;
                    }
                }
            }
        },
        onClickPrev(month) {
            month--;
            if (month <= 0) {
                this.currentMonth = 12;
                this.currentYear -= 1;
            }
            else {
                this.currentMonth -= 1;
            }
            this.init();
        },
        onClickNext(month) {
            month++;
            if (month > 12) {
                this.currentMonth = 1;
                this.currentYear += 1;
            }
            else {
                this.currentMonth += 1;
            }
            this.init();
        },
        isToday(year, month, day) {
            let date = new Date();
            return year == date.getFullYear() && month == date.getMonth() + 1 && day == date.getDate();
        },
        isHoliday(year, month, day) {
            if (day != '') {
                month = month.toString().padStart(2, "0");
                day = day.toString().padStart(2, "0");
                var date = year.toString() + '-' + month + '-' + day;
                this.currentDay = day;
                return this.holidaysMap.get(date) || false;
            }
        },
        getDayOffList(day) {
            var month = this.currentMonth.toString().padStart(2, "0");
            var day = day.toString().padStart(2, "0");
            var date = this.currentYear.toString() + '-' + month + '-' + day;
            var oneDayOffList = [];
            var oneDayOffList2=[];
            for (let i = 0; i < this.dayOffList.itemNum; i++) {
                if (this.dayOffList.list[i].date == date) {
                    oneDayOffList.push(this.dayOffList.list[i].userName);
                    oneDayOffList2.push(this.dayOffList.list[i])
                }
            }
            return oneDayOffList2.sort();
        },
        onClickToday() {
            //현재 날짜 초기화
            let date = new Date();
            this.currentYear = date.getFullYear();
            this.currentMonth = date.getMonth() + 1;
            this.currentDay = date.getDate();
            this.init();
        },
        reload() {
            this.dayOffList = [];
            this.retrieveHolidayList();
            this.retrieveDayOff();
            this.init();
        },
        //chatterDayOff2.vue 에서 변경사항이 있으면 reload(변경사항 반영)
        getIsDayOffUpdated(){
            this.reload();
        },
        //chatterHoliday2.vue 에서 addHoliday, deleteHoliday 하면 mainCalendar.vue 에서 데이터 처리
        getIsHolidayUpdated(holiday, flag){
            //Add Holiday
            if(flag==true){
                this.addHoliday(holiday);
            }
            //Delete Holiday
            else{
                this.deleteHoliday(holiday);
            }
        },
        async deleteHoliday(holiday) {
            let confirmed = await this.$bvModal.msgBoxConfirm(`${holiday.holidayDate} : ${holiday.holidayName}, 휴일 정보를 삭제하시겠습니까?`, { title: "Confirm" });
            if (!confirmed) return;
            try {
                this.loading = true;
                const response = await axios.post("chatter/removeHolidays/" + holiday.holidayDate, {}, {
                    headers: {
                        Authorization: accessToken()
                    }
                })
                this.reload();
            } catch (error) {
                this.loading = false;
                this.showError(error);
            } finally {
                this.loading = false;
            }
        },
        async addHoliday(holiday) {
            await this.$validator.validate();
            if (this.errors && this.errors.items.length > 0) {
                const errorItems = this.errors.items;
                const errorItemsLength = errorItems.length;
                for (let i = 0; i < errorItemsLength; i++) {
                    const error = errorItems[i];
                    this.$bvToast.toast(error.msg, {
                        title: `Notification`,
                        toaster: "b-toaster-bottom-center",
                        solid: true,
                        appendToast: false,
                        autoHideDelay: 400,
                        variant: "danger"
                    });
                    if (this.$refs[error.field]) this.$refs[error.field].focus();
                    break;
                }
                return;
            }
            try {
                this.loading = true;
                holiday.holidayDate = this.$moment(holiday.holidayDate).format('YYYY-MM-DD');

                const response = await axios.post("chatter/addHolidays", holiday, {
                    headers: {
                        Authorization: accessToken()
                    }
                });
                this.reload();
            } catch (error) {
                this.showError(error);
                this.loading = false;
            } finally {
                this.loading = false;
            }
        },
    }
}
</script>
  
<style type="text/css" scoped>
/* import font */
@import url('https://hangeul.pstatic.net/hangeul_static/css/nanum-gothic.css');

.card.calendar-wrap {
    margin-bottom: 5.333rem;
    border-radius: 30px;
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.05);
}
.card.calendar-wrap > .card-body {
    padding: 2rem 2.0833vw 2.666rem;
}
.card.calendar-wrap > .card-body > .card-body {
    padding: 0;
}
.calendar-wrap .card-title {
    padding: 0;
    margin-bottom: 0;
    border-bottom: none;
    color: #2E2E38;
    font-family: 'NanumGothic';
    font-size: 30px;
    font-weight: 700;
    line-height: 150%;
}
.calendar-wrap .content {
    margin-top: 1.333rem;
}
.calendar-wrap .content-wrap {
    display: flex;
    justify-content: space-between;
    gap: 0 1.5625vw;
}
.calendar-wrap .content-left {
    width: 66%;
    padding: 1.041vw;
    border-radius: 20px;
    border: 1px solid #DDDDE3;
}
.calendar-wrap .content-right {
    width: 32%;
    padding: 0 1.041vw 1.041vw;
    border-radius: 20px;
    background: #F6F6FA;
}
.calendar-wrap .calendar-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-left: 0.933rem;
    color: #2E2E38;
    font-family: 'NanumGothic';
    font-size: 24px;
    font-weight: 700;
    line-height: 150%;
    cursor: pointer;
}
.calendar-wrap .calendar-title .pagination {
    display: flex;
    align-items: center;
    gap: 0 0.666rem;
}
.calendar-wrap .calendar-title .pagination a {
    display: block;
    width: 30px;
    height: 30px;
    border-radius: 50%;
    border: 1px solid #E7E7EE;
    background-color: #FFF;
    background-repeat: no-repeat;
    background-size: 12px 12px;
    background-position: center center;
    background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none"><path d="M7 2L3 6L7 10" stroke="%232E2E38" stroke-linecap="round"/></svg>');
}
.calendar-wrap .calendar-title .pagination a:hover {
    border-color: #2E2E38;
}
.calendar-wrap .calendar-title .pagination .btn-next {
    transform: rotate(180deg);
}
.calendar-wrap .calendar-table {
    width: 100%;
    margin-top: 1.066rem;
    table-layout: fixed;
}
.calendar-wrap .calendar-table thead tr th {
    padding: 0.666rem 0.933rem 1.066rem 0.666rem;
    color: #2E2E38;
    font-family: 'NanumGothic';
    font-size: 14px;
    font-weight: 500;
    line-height: 150%;
    border-bottom: 1px solid #747480;
}
.calendar-wrap .calendar-table thead tr th.sun {
    color: #FF0000;
}
.calendar-wrap .calendar-table thead tr th.sat {
    color: #1755CC;
}
.calendar-wrap .calendar-table tbody tr td {
    padding: 0.52vw 0.52vw 0.729vw;
    vertical-align: unset;
    border-right: 1px solid #DDDDE3;
    border-bottom: 1px solid #DDDDE3;
}
.calendar-wrap .calendar-table tbody tr td:last-child {
    border-right: none;
}
.calendar-wrap .calendar-table tbody tr:last-child td {
    border-bottom: none;
}
.calendar-wrap .calendar-table .date {
    margin-bottom: 6px;
    color: #2E2E38;
    font-family: 'NanumGothic';
    font-size: 18px;
    font-weight: 700;
    line-height: 150%;
}
.calendar-wrap .calendar-table .today .day-text {
    position: relative;
    width: fit-content;
    color: #FFE600;
}
.calendar-wrap .calendar-table .today .day-text::before {
    content: '';
    display: block;
    position: absolute;
    top: 50%;
    left: 50%;
    width: 36px;
    height: 36px;
    background-color: #2E2E38;
    transform: translate(-50%, -50%);
    border-radius: 50%;
}
.calendar-wrap .calendar-table .today .day-text span {
    position: relative;
}
.calendar-wrap .calendar-table .holiday-text {
    margin-top: 2px;
    font-family: 'NanumGothic';
    font-size: 12px;
    font-weight: 500;
    line-height: 150%;
}
.calendar-wrap .calendar-table .dayoff-list {
    position: relative;
    height: 96px;
}
.calendar-wrap .calendar-table .dayoff-list .user {
    padding: 1px 0 1px 0.416vw;
    margin-bottom: 6px;
    border-radius: 4px;
    background: #F6F6FA;
    color: #000;
    font-family: 'NanumGothic';
    font-size: 12px;
    font-weight: 500;
    line-height: 150%;
}
.calendar-wrap .calendar-table .dayoff-list .others {
    padding-left: 0.416vw;
    color: #000;
    font-family: 'NanumGothic';
    font-size: 12px;
    font-weight: 500;
    line-height: 150%;
}
.calendar-wrap .calendar-table td:hover .balloon-left {
    display: block;
    z-index: 1;
}
.calendar-wrap .calendar-table .balloon-left {
    position: absolute;
    display: none;
    padding: 1.066rem;
    min-width: 120px;
    top: 9px;
    left: calc(100% + 9px);
    border-radius: 0px 20px 20px 20px;
    border: 1px solid #747480;
    background: #F6F6FA;
    box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.20);
}
.calendar-wrap .calendar-table .balloon-left > div {
    padding: 1px 0 1px 0.416vw;
    margin-bottom: 6px;
    border-radius: 4px;
    color: #000;
    font-family: 'NanumGothic';
    font-size: 12px;
    font-weight: 500;
    line-height: 150%;
    background-color: #FFF;
}
.calendar-wrap .calendar-table .balloon-left > div:last-child {
    margin-bottom: 0;
}
.calendar-wrap .content-right .card-body {
    padding: 0;
    margin-top: 1.6rem;
}
.calendar-graph {
    width: 100%;
    padding: 0 2.0833vw;
    margin-top: 2rem;
    border-radius: 20px;
    border: 1px solid #DDDDE3;
}
</style>
<style>
.calendar-wrap .content-right .tabs .card-header {
    padding: 0;
    border-radius: 0;
    background-color: transparent !important;
    border-bottom: none;
}
.calendar-wrap .content-right .tabs .card-header-tabs {
    margin: 0;
    gap: 0 2rem;
    border-bottom: 1px solid #DDDDE3;
}
.calendar-wrap .content-right .tabs .nav-tabs .nav-item {
    margin-bottom: 0;
}
.calendar-wrap .content-right .tabs .nav-tabs .nav-link {
    margin-bottom: 0;
    padding: 1.333rem 0.666rem 1.066rem;
    border-radius: 0;
    border: none;
    color: #747480;
    font-family: 'NanumGothic';
    font-size: 18px;
    font-weight: 500;
    line-height: 150%;
}
.calendar-wrap .content-right .nav-tabs .nav-link.active, 
.calendar-wrap .content-right .nav-tabs .nav-item.show .nav-link {
    color: #2E2E38;
    font-weight: 700;
    background-color: transparent;
    border-bottom: 3px solid #2E2E38;
}
</style>